<div class="header">
  <div class="header__input-wrapper orders__input-wrapper">
    <ui-text-field
      formControlName="search"
      id="search"
      iconName="pi pi-search"
      [placeholder]="placeholder()" />
  </div>

  @if (dropdownOptions().length) {
    <div class="header__dropdown-wrapper orders__dropdown-wrapper">
      <ui-dropdown
        id="status"
        placeholder="All Status"
        formControlName="status"
        [options]="dropdownOptions()" />
    </div>
  }
</div>
